import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { getSecurityInfo, getDeviceData, isSecureEnvironment } from './utils/deviceDataValidator';

// Expor funções de segurança no window para testes no console
if (typeof window !== 'undefined') {
  (window as any).getSecurityInfo = getSecurityInfo;
  (window as any).getDeviceData = getDeviceData;
  (window as any).isSecureEnvironment = isSecureEnvironment;
  console.log('[SECURITY] Funções de teste disponíveis no console:');
  console.log('  - getSecurityInfo() - Ver informações de segurança');
  console.log('  - getDeviceData() - Ver dados do dispositivo');
  console.log('  - isSecureEnvironment() - Verificar se ambiente é seguro');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  
  //<React.StrictMode>
    <BrowserRouter>
        <App />
    </BrowserRouter>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
